import api from "./api";
import {
  Empresa,
  EmpresaCreate,
  EmpresaUpdate,
  PaginatedEmpresaList,
} from "../types/empresa";

const BASE_URL = "/api/assinantes/";

export const empresaService = {
  getAll: async (): Promise<Empresa[]> => {
    const response = await api.get<PaginatedEmpresaList>(
      `${BASE_URL}?limit=1000`
    );
    return response.data.results;
  },

  listar: async (
    limit?: number,
    offset?: number,
    search?: string
  ): Promise<PaginatedEmpresaList> => {
    const params = new URLSearchParams();
    if (limit) params.append("limit", String(limit));
    if (offset) params.append("offset", String(offset));
    if (search) params.append("search", search);
    const response = await api.get<PaginatedEmpresaList>(
      `${BASE_URL}?${params.toString()}`
    );
    return response.data;
  },

  criar: async (
    data: EmpresaCreate
  ): Promise<Empresa & { setup_link?: string; setup_token?: string }> => {
    const response = await api.post<
      Empresa & { setup_link?: string; setup_token?: string }
    >(BASE_URL, data);

    // Garantir que exista um setup_link consistente para o frontend, mesmo quando o backend só retornar setup_token
    const payload = response.data as any;
    if (!payload.setup_link && payload.setup_token) {
      payload.setup_link = `https://nossoapp.com/cadastrar-senha?codigo=${payload.setup_token}`;
    }

    return payload;
  },

  detalhar: async (id: number): Promise<Empresa> => {
    const response = await api.get<Empresa>(`${BASE_URL}${id}/`);
    return response.data;
  },

  atualizar: async (
    id: number,
    data: Partial<EmpresaUpdate>
  ): Promise<Empresa> => {
    const response = await api.patch<Empresa>(`${BASE_URL}${id}/`, data);
    return response.data;
  },

  excluir: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}${id}/`);
  },

  reenviarConvite: async (
    id: number
  ): Promise<{ detail: string; setup_link?: string; setup_token?: string }> => {
    const response = await api.post<{
      detail: string;
      setup_link?: string;
      setup_token?: string;
    }>(`${BASE_URL}${id}/reenviar-convite/`);

    const payload: any = response.data;
    if (!payload.setup_link && payload.setup_token) {
      payload.setup_link = `https://nossoapp.com/cadastrar-senha?codigo=${payload.setup_token}`;
    }

    return payload;
  },

  adicionarCidade: async (
    empresaId: number,
    municipioId: number
  ): Promise<any> => {
    const response = await api.post(
      `${BASE_URL}${empresaId}/adicionar-cidade/`,
      { municipio_id: municipioId }
    );
    return response.data;
  },

  adicionarSegmento: async (
    empresaId: number,
    segmento: string
  ): Promise<any> => {
    const response = await api.post(
      `${BASE_URL}${empresaId}/adicionar-segmento/`,
      { segmento }
    );
    return response.data;
  },
};
